<!-- Header -->

<template>
  <header class="mock-modal-header container-fluid py-3 d-flex align-items-center">
    <div class="utility-branding mr-auto">
      <img class="utility-logo"
        v-show="showLogo"
        v-bind:src="utilityLogoSrc"
        v-on:error="hideLogo">
    </div>

    <div class="powered-by d-flex ml-2 align-items-center">
      <small class="text-muted text-right">
        Powered by<br>
        Enervee
      </small>
      <img class="enervee-logo ml-2" v-bind:src="enerveeLogoSrc">
    </div>
    <button type="button"
      v-on:click="postMessageToWindow"
      class="close"
      aria-label="Close"
      tabindex="2">
      <span aria-hidden="true">
        &times;
      </span>
    </button>
  </header>
</template>

<script>
import postMessageToWindow from '@/api/postMessageToWindow';
import SegmentMixin from '@/mixins/SegmentMixin';

export default {
  name: 'Header',
  mixins: [
    SegmentMixin,
  ],
  data() {
    return {
      showLogo: true,
    };
  },
  computed: {
    utilityLogoSrc() {
      return this.$store.state.siteSettings.settings.rebateConfig.utilityLogo;
    },
    enerveeLogoSrc() {
      return this.$store.state.siteSettings.settings.rebateConfig.enerveeLogo;
    },
  },
  methods: {
    /**
     * Posts close message to parent window on button click
     */
    postMessageToWindow() {
      const form = this.$store.state.forms.currentForm;
      const data = {
        close: true,
        reason: 'dismiss',
        location: form,
        data: {
          hasShippingData: this.$store.state.hasShippingData,
        },
      };
      // Callback to close the iframe. To be executed by segment after
      // tracking and a short timeout.
      const callback = () => postMessageToWindow(data);
      this.trackCurrentFormEvent(
        this.segment.constants.events.CLOSED,
        null,
        callback,
      );
    },

    /**
     * Hides logo image, usually in case of an error fetching it
     */
    hideLogo() {
      this.showLogo = false;
    },
  },
};
</script>
